__turbopack_context__.v({
  "carouselArrow": "JsE9nG_carouselArrow",
  "carouselArrowPrev": "JsE9nG_carouselArrowPrev",
  "carouselArrows": "JsE9nG_carouselArrows",
  "carouselTrack": "JsE9nG_carouselTrack",
  "carouselWindow": "JsE9nG_carouselWindow",
  "courseCard": "JsE9nG_courseCard",
  "courseCardDone": "JsE9nG_courseCardDone",
  "courseChevron": "JsE9nG_courseChevron",
  "courseDescription": "JsE9nG_courseDescription",
  "courseIcon": "JsE9nG_courseIcon",
  "courseText": "JsE9nG_courseText",
  "courseTitle": "JsE9nG_courseTitle",
  "courseTop": "JsE9nG_courseTop",
  "panel": "JsE9nG_panel",
  "panelHead": "JsE9nG_panelHead",
  "panelTitle": "JsE9nG_panelTitle",
  "root": "JsE9nG_root",
  "videoCard": "JsE9nG_videoCard",
  "videoGrid": "JsE9nG_videoGrid",
  "videoModalClose": "JsE9nG_videoModalClose",
  "videoModalContent": "JsE9nG_videoModalContent",
  "videoModalFrame": "JsE9nG_videoModalFrame",
  "videoModalHeader": "JsE9nG_videoModalHeader",
  "videoModalOverlay": "JsE9nG_videoModalOverlay",
  "videoModalTitle": "JsE9nG_videoModalTitle",
  "videoPlayBadge": "JsE9nG_videoPlayBadge",
  "videoThumb": "JsE9nG_videoThumb",
  "videoThumbArt": "JsE9nG_videoThumbArt",
  "videoTitle": "JsE9nG_videoTitle",
  "viewAllLink": "JsE9nG_viewAllLink",
});
